var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"20px","background-color":"#272727","min-height":"calc(100vh)"}},[(_vm.workspaceID)?_c('list',{attrs:{"locale":_vm.locale,"workspaceID":_vm.workspaceID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }